import ggLayout, { LayoutComponent_LocalLoader as LocalLoader } from 'ggApp/modules/layout';
import ggRouter from 'ggApp/modules/router';
import ggBraintree from 'ggApp/modules/braintree';
import ggNotification from 'ggApp/modules/notification';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector, createStructuredSelector } from 'reselect';
import shortid from 'shortid';

const generateSuccessNotification = () => ({
    id: shortid.generate(),
    message: 'Payment method has been created and set as new!',
    level: 'success',
});

const generateFailureNotification = () => ({
    id: shortid.generate(),
    message:
        "We're temporarily having connectivity issues with PayPal. If you experience any redirection difficulty, please use a credit card instead.",
    level: 'warning',
});

@connect(
    createStructuredSelector({
        routerParams: ggRouter.selectors.params,
        routerLocationQuery: ggRouter.selectors.locationQuery,
        paypalFrom: createSelector(
            ggRouter.selectors.locationQuery,
            ggBraintree.selectors.FN_paypalFrom,
        ),
    }),
    (dispatch) => ({
        layoutActions: bindActionCreators(ggLayout.actions, dispatch),
        braintreeActions: bindActionCreators(ggBraintree.actions, dispatch),
        routerActions: bindActionCreators(ggRouter.actions, dispatch),
        notificationActions: bindActionCreators(ggNotification.actions, dispatch),
    }),
)
export default class BraintreePaypalConfirm extends Component {
    componentWillMount() {
        const {
            layoutActions,
            braintreeActions,
            routerActions,
            notificationActions,
            paypalFrom,
            routerLocationQuery,
        } = this.props;

        layoutActions.globalLoaderHide();
        if (paypalFrom.condition) {
            braintreeActions.confirmPaypal(routerLocationQuery.orderNumber, paypalFrom.data).then(
                () => {
                    routerActions.transitionTo(routerLocationQuery.nextUrl);
                    notificationActions.addNotification(generateSuccessNotification());
                },
                () => {
                    routerActions.transitionTo(routerLocationQuery.backUrl);
                    notificationActions.addNotification(generateFailureNotification());
                },
            );
        } else if (routerLocationQuery.backUrl) {
            routerActions.transitionTo(routerLocationQuery.backUrl);
            notificationActions.addNotification(generateFailureNotification());
        } else {
            window.location.href = window.location.origin;
        }
    }

    render() {
        return <LocalLoader active />;
    }
}
